import React, { useEffect, useState } from 'react'

import '../index.css'

import {
    withStyles,
    NativeSelect,
    InputBase
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

import {Pagination} from '@material-ui/lab'

import ViewAns from '../components/view'
import useDebounce from '../components/useDebounce'
const PaginationDark = withStyles({
    root: {
        marginTop:25,
        '& .MuiPaginationItem-root': {
            color: 'white',
        },
        '& .Mui-selected': {
            backgroundColor: 'transparent',
            color:'#19D5C6',
        },
}
})(Pagination)

const PaginationLight = withStyles({
    root: {
        marginTop:25,
        '& .MuiPaginationItem-root': {
            color:'black',
        },
        '& .Mui-selected': {
            backgroundColor: 'transparent',
            color:'#19D5C6',
        },
}
})(Pagination)

const useStyles = makeStyles({
    inputDark:{
        borderBottom:'1px solid white',
        color:'white',
        fontSize:20,
        marginBottom:16,
    },
    inputLight:{
        borderBottom:'1px solid black',
        color:'black',
        fontSize:20,
        marginBottom:16,
    },
    selectDark: {
        color:'white'
    },
    selectLight: {
        color:'black'
    }
});


const Search = props => {
    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [current, setCurrent] = useState([])
    const pageCount = 20
    const [subject, setSubject] = useState('')
    const [subjectList, setSubjectList] = useState([])

    const [search, setSearch] = useState('')
    const debounceSearchTerm = useDebounce(search, 500)

    const classes = useStyles()

    useEffect(async () => {
        const searchParams = new URLSearchParams(props.location.search)
        //console.log(props)
        //SetPage
        const p = parseInt(searchParams.get('page') || '1', 10)
        setPage(p)
        searchParams.set('page',p)
        const res = await fetch(`${document.location.origin}/.netlify/functions/subjects`)
        const res_json = await res.json()
        res_json.unshift({
            term: 0,
            subject: 'Wybierz przedmiot'
        })
        setSubjectList(res_json)

        if(searchParams.get('subject') && res_json.find(x => x.subject === searchParams.get('subject'))){
            const res_q = await fetch(`${document.location.origin}/.netlify/functions/find?subject=${searchParams.get('subject')}`)
            const req_q_json = await res_q.json()
            setSubject(searchParams.get('subject'))
            setData(req_q_json.data)
            console.log(data)
            setCurrent(req_q_json.data.slice((p-1)*pageCount, ((p-1)*pageCount)+pageCount))
        }
        props.history.push("?" + searchParams.toString())
    },[])
  
    useEffect(() => {
        
        const searchParams = new URLSearchParams(props.location.search)
        const p = parseInt(searchParams.get('page') || '1', 10)
        if(!searchParams.get('subject')){
            setSubject(`[0] Wybierz przedmiot`)
            setData([])
            setCurrent([])
            setSearch('')
        } else {
            setPage(p)
            setCurrent(data.slice((p-1)*pageCount, ((p-1)*pageCount)+pageCount))
        }

    },[props.location.search])

    useEffect(() => {
        if(search){
            apiCall(debounceSearchTerm)
        } else {
            if(search === '' && subject !== "[0] Wybierz przedmiot" && subject){
                //const searchParams = new URLSearchParams(props.location.search)
                fetch(`${document.location.origin}/.netlify/functions/find?subject=${subject}`)
                    .then(x => x.json())
                    .then((x) => {
                        console.log(x)
                        setData(x.data)
                        setCurrent(x.data.slice((1-1)*pageCount, ((1-1)*pageCount)+pageCount))
                        //searchParams.set('subject', subject)
                        //props.history.push("?" + searchParams.toString())
                    })
            }
        }
    }, [debounceSearchTerm])
    
    
    const apiCall = async (e) => {
        console.log(e)
        const searchParams = new URLSearchParams(props.location.search)
        const res_q = await fetch(`${document.location.origin}/.netlify/functions/search?subject=${subject}&s=${e}`)
        const req_q_json = await res_q.json()
        setData(req_q_json.data)
        setCurrent(req_q_json.data.slice((1-1)*pageCount, ((1-1)*pageCount)+pageCount))
        searchParams.set('subject', subject)
        props.history.push("?" + searchParams.toString())
    }


    const handleChange = (event, value) => {
        setPage(value);
        const searchParams = new URLSearchParams(props.location.search)
        searchParams.set('page',value)
        //console.log(searchParams.toString())
        props.history.push("?" + searchParams.toString())
        setCurrent(data.slice((value-1)*pageCount, ((value-1)*pageCount)+pageCount))
        window.scrollTo(0, 0)
    };


    return (
        <div>
            <div style={{
                width:'100%',
                marginTop:'25px'
            }}>
                <NativeSelect
                    classes={{
                        root:props.isDark ? classes.inputDark : classes.inputLight,
                        icon:props.isDark ? classes.selectDark : classes.selectLight
                    }}
                    style={{
                        width:'100%'
                    }}
                    label
                    value={subject}
                    disableUnderline={true}
                    onChange={async (event) => {
                        let { value } = event.target
                        setSubject(value)
                        const searchParams = new URLSearchParams(props.location.search)
                        if(value !== "Wybierz przedmiot"){
                            const res_q = await fetch(`${document.location.origin}/.netlify/functions/find?subject=${value}`)
                            const req_q_json = await res_q.json()
                            console.log(req_q_json)
                            setData(req_q_json.data)
                            setCurrent(req_q_json.data.slice((1-1)*pageCount, ((1-1)*pageCount)+pageCount))
                            searchParams.set('subject', value)
                            props.history.push("?" + searchParams.toString())
                        } else {
                            searchParams.delete('subject')
                            setData([])
                            setCurrent([])
                            props.history.push("?" + searchParams.toString())
                        }
                    }}
                >
                {subjectList.map(y => <option key={y.subject} value={y.subject} style={{color:'black'}}>[{y.term}] {y.subject}</option>)}
                </NativeSelect>
                <InputBase
                    fullWidth
                    placeholder="Wpisz szukaną fraze"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    id="custom-css-standard-input"
                    label="Custom CSS"
                    style={{
                        borderBottom:'1px solid white',
                        color:'white'
                    }}
                />
            </div>

            {data.length !== 0 ? 
                <div style={{display:'flex', justifyContent:'center'}}>
                    {props.isDark ? 
                    <PaginationDark count={parseInt(data.length/pageCount)+(data.length % pageCount === 0 ? 0 : 1)} page={page} onChange={handleChange} />
                    :
                    <PaginationLight count={parseInt(data.length/pageCount)+(data.length % pageCount === 0 ? 0 : 1)} page={page} onChange={handleChange} />
                    }
                </div>
                : 
                <div style={{marginTop:25, display:'flex', justifyContent:'center', color: props.isDark ? "white" : "black"}}>
                    BRAK
                </div>
            }
            <div id="ansContainer">
                {current.map(x => {
                    return (<ViewAns id="ansViw" isDark={props.isDark} key={x._id} data={x}></ViewAns>)
                })}
            </div>
            {data.length !== 0 ? 
                <div style={{display:'flex', justifyContent:'center'}}>
                    {props.isDark ? 
                        <PaginationDark count={parseInt(data.length/pageCount)+(data.length % pageCount === 0 ? 0 : 1)} page={page} onChange={handleChange} />
                        :
                        <PaginationLight count={parseInt(data.length/pageCount)+(data.length % pageCount === 0 ? 0 : 1)} page={page} onChange={handleChange} />
                    }
                </div>
                :
                null
            }
        </div>
    )
}

export default Search;